import React from 'react';
import {
  Cell,
  Pie,
  PieChart as RechartsPieChart,
  ResponsiveContainer,
  Tooltip,
} from 'recharts';
import { CHART_SERIES_COLORS } from '@/features/ai-agents/chat/MarkdownTableVisualization/constants';
import { renderPieValueLabel } from '@/features/ai-agents/chat/MarkdownTableVisualization/helpers';
import {
  ChartRow,
  ChartValueFormatter,
} from '@/features/ai-agents/chat/MarkdownTableVisualization/types';

interface PieChartProps {
  data: ChartRow[];
  formatValue: ChartValueFormatter;
}

export function PieChart({ data, formatValue }: PieChartProps) {
  const formattedData = data.map((row) => ({
    ...row,
    formattedY: formatValue(row.y),
  }));

  return (
    <ResponsiveContainer width="100%" height={300}>
      <RechartsPieChart>
        <Tooltip formatter={formatValue} />
        <Pie
          data={formattedData}
          dataKey="y"
          nameKey="x"
          cx="50%"
          cy="50%"
          innerRadius={52}
          outerRadius={120}
          paddingAngle={2}
          cornerRadius={3}
          labelLine={{ stroke: `#9ca3af`, strokeWidth: 1 }}
          label={renderPieValueLabel}
          isAnimationActive={false}
        >
          {formattedData.map((row, index) => (
            <Cell
              key={`${row.x}-${index}`}
              fill={CHART_SERIES_COLORS[index % CHART_SERIES_COLORS.length]}
            />
          ))}
        </Pie>
      </RechartsPieChart>
    </ResponsiveContainer>
  );
}
